<template>
    <DModal
        :title="$t('settings_allowed_ips.add_ip_range_modal_title')"
        :show="showModal"
        is-confirm
        is-awaiting-validation
        @confirm="submit"
    >
        <div
            v-if="showModal"
            class="m-3"
        >
            <DFormRow
                :label="$t('settings_allowed_ips.from_ip')"
                is-required
                :error="errorsData?.startIp"
            >
                <DInput
                    v-model="data.startIp"
                    :placeholder="$t('settings_allowed_ips.from_ip')"
                />
            </DFormRow>
            <DFormRow
                is-required
                :label="$t('settings_allowed_ips.to_ip')"
                :error="errorsData?.endIp"
            >
                <DInput
                    v-model="data.endIp"
                    :placeholder="$t('settings_allowed_ips.to_ip')"
                />
            </DFormRow>
            <p
                v-if="submitSuccess"
                class="text-success"
            >
                {{ $t('settings_allowed_ips.add_success') }}
            </p>
        </div>
    </DModal>
</template>

<script setup>
import { ref, onUpdated } from 'vue'
import axios from 'axios'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    ownerGroup: {
        type: Number,
        default: null
    }
})

onUpdated(() => {
    errorsData.value = []
})

const emit = defineEmits(['update:allowedIps'])

const data = {
    startIp: '',
    endIp: ''
}
const submitSuccess = ref(false)
const errorsData = ref([])

function submit () {
    submitSuccess.value = false
    errorsData.value = []

    axios.post(route('settings.allowed-ips.store'), {
        startIp: data.startIp,
        endIp: data.endIp,
        groupId: props.ownerGroup
    })
        .then(response => {
            emit('update:allowedIps', response.data.allowedIps)
            submitSuccess.value = true
        })
        .catch(error => {
            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors
                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
        })
}
</script>
<style>
</style>
